<template>
    <CompanyBoxContent v-if="jobPositions && jobPositions.length > 0" :title="$t('company.jobPositions') + ':'">
        <template #data>
            <div class="row box p-0">
                <div v-for="job in jobPositions" :key="job.id" :class="['p-3 inner', job.id % 2 === 0 ? 'bg' : '']">
                    <span>{{ job.data.pozadovanaProfese.cs }}</span>
                    <div class="row">
                        <div>
                            <span class="me-1">{{ $t('company.insertDate') }}:</span>
                            <i18n-d tag="span" :value="new Date(job.data.datumVlozeni)"></i18n-d>
                        </div>
                        <div>
                            <span class="me-1">{{ $t('company.wageFrom') }}:</span>
                            <span>{{ job.data.mesicniMzdaOd }}</span>
                        </div>
                        <div>
                            <span class="me-1">{{ $t('company.wageTo') }}:</span>
                            <span>{{ job.data.mesicniMzdaDo }}</span>
                        </div>
                        <div>
                            <span class="me-1">{{ $t('company.wageType') }}:</span>
                            <span>{{ job.data.typMzdy }}</span>
                        </div>
                        <div>
                            <span class="me-1">{{ $t('company.numberOfPositions') }}:</span>
                            <span>{{ job.data.pocetMist }}</span>
                        </div>
                        <div>
                            <span class="me-1">{{ $t('company.startingDate') }}:</span>
                            <i18n-d tag="span" :value="new Date(job.data.terminZahajeniPracovnihoPomeru)"></i18n-d>
                        </div>
                        <div>
                            <span class="me-1">{{ $t('company.workplace') }}:</span>
                            <div v-for="workplace in job.data.mistoVykonuPrace.pracoviste">
                                <span>{{ workplace.adresa.kodAdresnihoMista }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <span class="me-1">{{ $t('company.workType') }}:</span>
                            <span>{{ job.data.pracovnePravniVztahy.map(vztah => vztah.id).join(', ') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </CompanyBoxContent>
</template>


<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue"

export default {
    props: {
        jobPositions: {
            type: Array,
            required: true
        }
    },
    components: {
        CompanyBoxContent,
    },
    data() {
        return {

        }
    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.inner {
    border-radius: 35px;
}

.bg {
    background-color: $grey;
}
</style>